"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _default = function _default(options) {
  var fetchOfferUrl = options.fetchOfferUrl,
    _options$query = options.query,
    changeAmount = _options$query.changeAmount,
    id = _options$query.id,
    offerId = _options$query.offerId;
  var params = {
    changeAmount: changeAmount,
    id: id,
    offerId: offerId
  };
  return _lcHttp.default.get(fetchOfferUrl, {
    params: params
  }).then(function (response) {
    var _response$data = response.data,
      application = _response$data.originalOffer,
      offers = _response$data.offers;
    return {
      application: application,
      offers: offers
    };
  }).catch(function () {
    console.log('An error has occurred in attempting to fetch offer details: ', params);
  });
};
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');